<app-splash-screen />
<router-outlet />
